import Footer from "../../component/footer";
import Navbar from "../../component/navbar";
import { Link } from "react-router-dom";
import React, { useState, useEffect } from "react";
import Modal from "../../component/modal";

export default function PageGA() {
  const [showModal, setShowModal] = useState(false);
  const [titleModal, setTitleModal] = useState("");

  const showModalPreview = (data) => {
    setTitleModal(data.title);
    setShowModal(true); // Show modal
  };

  const closeModal = () => setShowModal(false);

  const AnnouncementAndOrder = () => {
    const [search, setSearch] = useState("");
    const [filteredData, setFilteredData] = useState([]);
    const [tabActive, setTabActive] = useState(1);
    const iconWord =
      "https://img.icons8.com/?size=100&id=13674&format=png&color=000000";
    const iconPDF =
      "https://img.icons8.com/?size=100&id=aBrh3QHCPxYu&format=png&color=000000";
    const iconExcel =
      "https://img.icons8.com/?size=100&id=13654&format=png&color=000000";

    const dataIndex1 = [
      {
        id: 1,
        title: "แต่งตั้งอธิการบดีมหาวิทยาลัยเชียงใหม่",
        link: "/FILE_GENERAL/001/T_0006-ประกาศแต่งตั้งอธิการบดีในราชกิจจานุเบกษา.PDF.pdf",
        number: "",
        type: "pdf",
        date: "19 สิงหาคม 2565",
      },
      {
        id: 2,
        title: "แต่งตั้งบุคคลให้ดำรงตำแหน่งรองอธิการบดีมหาวิทยาลัยเชียงใหม่",
        link: "/FILE_GENERAL/001/คำสั่ง-แต่งตั้งรองอธิการบดี-มช.-2565.pdf",
        number: "2516/2565",
        type: "pdf",
        date: "27 สิงหาคม 2565",
      },
      {
        id: 3,
        title: "แต่งตั้งคณบดีคณะสัตวแพทยศาสตร์ มหาวิทยาลัยเชียงใหม่",
        link: "/FILE_GENERAL/001/คำสั่งแต่งตั้งคณบดี 25 มี.ค.65.pdf",
        number: "3881/2564",
        type: "pdf",
        date: "18 ธันวาคม 2564",
      },
    ];
    const dataIndex2 = [
      {
        id: 1,
        title: "มอบหมายและมอบอำนาจให้ผู้ดำรงตำแหน่งรองคณบดี และผู้ช่วยคณบดี",
        link: "/FILE_GENERAL/002/(036)มอบหมาบโดยคณะ อ.นิดหน่อย อ.สหัสชัย.pdf",
        number: "036/2568",
        type: "pdf",
        date: "30 มกราคม 2568",
      },
    ];
    const dataIndex3 = [
      // {
      //   id: 1,
      //   title: "ประกาศมหาวิทยาลัย/1",
      //   link: "#!",
      //   type: "pdf",
      //   date: "12 กุมภาพันธ์ 2566",
      // },
    ];
    const dataIndex4 = [
      // {
      //   id: 1,
      //   title: "ประกาศคณะฯ/1",
      //   link: "#!",
      //   type: "pdf",
      //   date: "12 กุมภาพันธ์ 2566",
      // },
    ];

    const handleActviceChange = (index) => {
      setTabActive(index);
      handleSearch(search, index);
    };

    const handleSearch = (searchValue, index) => {
      let data = [];
      if (index === 1) data = dataIndex1;
      if (index === 2) data = dataIndex2;
      if (index === 3) data = dataIndex3;
      if (index === 4) data = dataIndex4;

      const filtered = data.filter((item) =>
        item.title.toLowerCase().includes(searchValue.toLowerCase())
      );
      setFilteredData(filtered);
    };

    useEffect(() => {
      handleSearch(search, tabActive);
    }, [search, tabActive]);

    const renderTable = (data) => {
      return data.map((item, index) => (
        <tr key={index}>
          <td
            onClick={() => window.open(item.link)}
            className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 border border-gray-200"
          >
            <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800 cursor-pointer">
              ดาวน์โหลด
            </span>
          </td>
          <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 border border-gray-200">
            {item.title}
          </td>
          <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 border border-gray-200">
            {item.number}
          </td>
          <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 border border-gray-200">
            {item.date}
          </td>
          <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900 border border-gray-200">
            <img
              src={
                item.type === "word"
                  ? iconWord
                  : item.type === "pdf"
                  ? iconPDF
                  : iconExcel
              }
              alt=""
              className="w-8 h-8"
            />
          </td>
        </tr>
      ));
    };

    return (
      <>
        <div className="flex flex-col gap-3">
          <div className="flex justify-between items-center px-5">
            <div className="md:bg-gray-100 shadow-sm px-2 py-2  md:flex justify-start items-center gap-2 rounded-full">
              <div
                onClick={() => handleActviceChange(1)}
                className={`px-4 py-2 rounded-full flex gap-x-2 items-center hover:bg-[#9e76b4] ${
                  tabActive === 1 ? "bg-[#9e76b4] text-white" : "text-[#5eafd2]"
                } text-sm hover:text-white cursor-pointer transition-all duration-500 `}
              >
                <i className="fa fa-file"></i>
                <span>คำสั่งมหาวิทยาลัย</span>
              </div>
              <span className="md:block hidden">|</span>
              <div
                onClick={() => handleActviceChange(2)}
                className={`px-4 py-2 rounded-full flex gap-x-2 items-center hover:bg-[#9e76b4] ${
                  tabActive === 2 ? "bg-[#9e76b4] text-white" : "text-[#5eafd2]"
                } text-sm hover:text-white cursor-pointer transition-all duration-500 `}
              >
                <i className="fa fa-file"></i>
                <span>คำสั่งคณะฯ</span>
              </div>
              <span className="md:block hidden">|</span>
              <div
                onClick={() => handleActviceChange(3)}
                className={`px-4 py-2 rounded-full flex gap-x-2 items-center hover:bg-[#9e76b4] ${
                  tabActive === 3 ? "bg-[#9e76b4] text-white" : "text-[#5eafd2]"
                } text-sm hover:text-white cursor-pointer transition-all duration-500 `}
              >
                <i className="fa fa-file"></i>
                <span>ประกาศมหาวิทยาลัย</span>
              </div>
              <span className="md:block hidden">|</span>
              <div
                onClick={() => handleActviceChange(4)}
                className={`px-4 py-2 rounded-full flex gap-x-2 items-center hover:bg-[#9e76b4] ${
                  tabActive === 4 ? "bg-[#9e76b4] text-white" : "text-[#5eafd2]"
                } text-sm hover:text-white cursor-pointer transition-all duration-500 `}
              >
                <i className="fa fa-file"></i>
                <span>ประกาศคณะฯ</span>
              </div>
            </div>
            <div className="relative flex justify-end items-center">
              <input
                onChange={(e) => setSearch(e.target.value)}
                type="search"
                placeholder="ค้นหา"
                className="text-sm bg-gray-100 px-4 py-2 rounded-full focus:outline-none focus:ring-2 focus:ring-[#9e76b4] focus:border-transparent"
              />
            </div>
          </div>

          <div className="flex justify-start items-center">
            <div className="bg-white shadow-md rounded-lg overflow-hidden  md:w-50 w-full mx-4">
              <div className="overflow-x-auto overflow-y-scroll h-96 custom-scrollbar">
                <table className="min-w-full border-collapse border border-gray-200 ">
                  <thead className="bg-gray-50">
                    <tr>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border border-gray-200">
                        ดาวน์โหลด
                      </th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border border-gray-200">
                        ชื่อไฟล์
                      </th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border border-gray-200">
                        เลขคำสั่งที่
                      </th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border border-gray-200">
                        วันที่
                      </th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border border-gray-200">
                        ประเภทไฟล์
                      </th>
                    </tr>
                  </thead>
                  <tbody className="bg-white divide-y divide-gray-200">
                    {renderTable(filteredData)}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  };

  const MeetingResolution = () => {
    const iconWord =
      "https://img.icons8.com/?size=100&id=13674&format=png&color=000000";
    const iconPDF =
      "https://img.icons8.com/?size=100&id=aBrh3QHCPxYu&format=png&color=000000";
    const iconExcel =
      "https://img.icons8.com/?size=100&id=13654&format=png&color=000000";

    const [tabActive, setTabActive] = useState(1);
    const [search, setSearch] = useState("");
    const [filteredData, setFilteredData] = useState([]);

    const dataIndex1 = [
      // {
      //   id: 1,
      //   title: "19/2567",
      //   link: "https://www.cmu.ac.th/CMUArticle/ArticleDownload.aspx?id=cd2f9fe5-2240-461f-9f04-98e7aa19ee3e",
      //   type: "excel",
      //   date: "12 กุมภาพันธ์ 2566",
      // },
    ];

    // ฟังก์ชันสำหรับการค้นหา
    const handleSearch = (searchValue) => {
      const filtered = dataIndex1.filter(
        (item) =>
          item.title.toLowerCase().includes(searchValue.toLowerCase()) ||
          item.date.toLowerCase().includes(searchValue.toLowerCase())
      );
      setFilteredData(filtered);
    };

    // เรียกใช้ handleSearch เมื่อ search หรือ tabActive เปลี่ยนแปลง
    useEffect(() => {
      handleSearch(search);
    }, [search, tabActive]);

    return (
      <>
        <div className="flex flex-col gap-3">
          {/* ช่องค้นหา */}
          <div className="flex justify-end items-center px-5">
            <div className="relative flex justify-end items-center">
              <input
                onChange={(e) => setSearch(e.target.value)}
                type="search"
                placeholder="ค้นหา"
                className="bg-gray-100 px-4 py-2 rounded-full focus:outline-none focus:ring-2 focus:ring-[#9e76b4] focus:border-transparent"
              />
            </div>
          </div>

          {/* ตารางข้อมูล */}
          <div className="flex justify-start items-center">
            <div className="bg-white shadow-md rounded-lg overflow-hidden md:w-50 w-full mx-4">
              <div className="overflow-x-auto overflow-y-scroll h-96 custom-scrollbar">
                <table className="min-w-full border-collapse border border-gray-200">
                  <thead className="bg-gray-50">
                    <tr>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border border-gray-200">
                        ดาวน์โหลด
                      </th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border border-gray-200">
                        มติที่ประชุมครั้งที่
                      </th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border border-gray-200">
                        วันที่
                      </th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border border-gray-200">
                        ประเภทไฟล์
                      </th>
                    </tr>
                  </thead>
                  <tbody className="bg-white divide-y divide-gray-200">
                    {filteredData.map((item, index) => (
                      <tr key={index}>
                        <td
                          onClick={() => window.open(item.link)}
                          className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 border border-gray-200"
                        >
                          <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800 cursor-pointer">
                            ดาวน์โหลด
                          </span>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 border border-gray-200">
                          {item.title}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 border border-gray-200">
                          {item.date}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900 border border-gray-200">
                          <img
                            src={
                              item.type === "word"
                                ? iconWord
                                : item.type === "pdf"
                                ? iconPDF
                                : iconExcel
                            }
                            alt=""
                            className="w-8 h-8"
                          />
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  };

  const KnowledgeManagement = () => {
    const iconWord =
      "https://img.icons8.com/?size=100&id=13674&format=png&color=000000";
    const iconPDF =
      "https://img.icons8.com/?size=100&id=aBrh3QHCPxYu&format=png&color=000000";
    const iconExcel =
      "https://img.icons8.com/?size=100&id=13654&format=png&color=000000";

    const [tabActive, setTabActive] = useState(1);
    const [search, setSearch] = useState("");
    const [filteredData, setFilteredData] = useState([]);

    const dataIndex1 = [
      {
        id: 1,
        title: "คณะทำงานดำเนินกิจกรรมองค์กรแห่งการเรียน",
        link: "/FILE_GENERAL/KM/คณะทำงานดำเนินกิจกรรมองค์กรแห่งการเรียน.pdf",
        number: "392/2567",
        type: "pdf",
        date: "18 ธันวาคม 2567",
      },
    ];

    // ฟังก์ชันสำหรับการค้นหา
    const handleSearch = (searchValue) => {
      const filtered = dataIndex1.filter(
        (item) =>
          item.title.toLowerCase().includes(searchValue.toLowerCase()) ||
          item.date.toLowerCase().includes(searchValue.toLowerCase())
      );
      setFilteredData(filtered);
    };

    // เรียกใช้ handleSearch เมื่อ search หรือ tabActive เปลี่ยนแปลง
    useEffect(() => {
      handleSearch(search);
    }, [search, tabActive]);

    return (
      <>
        <div className="flex flex-col gap-3">
          {/* ช่องค้นหา */}
          <div className="flex justify-end items-center px-5">
            <div className="relative flex justify-end items-center">
              <input
                onChange={(e) => setSearch(e.target.value)}
                type="search"
                placeholder="ค้นหา"
                className="bg-gray-100 px-4 py-2 rounded-full focus:outline-none focus:ring-2 focus:ring-[#9e76b4] focus:border-transparent"
              />
            </div>
          </div>

          {/* ตารางข้อมูล */}
          <div className="flex justify-start items-center">
            <div className="bg-white shadow-md rounded-lg overflow-hidden md:w-50 w-full mx-4">
              <div className="overflow-x-auto overflow-y-scroll h-96 custom-scrollbar">
                <table className="min-w-full border-collapse border border-gray-200">
                  <thead className="bg-gray-50">
                    <tr>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border border-gray-200">
                        ดาวน์โหลด
                      </th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border border-gray-200">
                        ชื่อไฟล์
                      </th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border border-gray-200">
                        เลขคำสั่งที่
                      </th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border border-gray-200">
                        วันที่
                      </th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border border-gray-200">
                        ประเภทไฟล์
                      </th>
                    </tr>
                  </thead>
                  <tbody className="bg-white divide-y divide-gray-200">
                    {filteredData.map((item, index) => (
                      <tr key={index}>
                        <td
                          onClick={() => window.open(item.link)}
                          className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 border border-gray-200"
                        >
                          <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800 cursor-pointer">
                            ดาวน์โหลด
                          </span>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 border border-gray-200">
                          {item.title}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 border border-gray-200">
                          {item.number}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 border border-gray-200">
                          {item.date}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900 border border-gray-200">
                          <img
                            src={
                              item.type === "word"
                                ? iconWord
                                : item.type === "pdf"
                                ? iconPDF
                                : iconExcel
                            }
                            alt=""
                            className="w-8 h-8"
                          />
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  };

  const ManualGa = () => {
    const iconWord =
      "https://img.icons8.com/?size=100&id=13674&format=png&color=000000";
    const iconPDF =
      "https://img.icons8.com/?size=100&id=aBrh3QHCPxYu&format=png&color=000000";
    const iconExcel =
      "https://img.icons8.com/?size=100&id=13654&format=png&color=000000";

    const [tabActive, setTabActive] = useState(1);
    const [search, setSearch] = useState("");
    const [filteredData, setFilteredData] = useState([]);

    const dataIndex1 = [
      {
        id: 1,
        title: "คู่มือการปฏิบัติงานผ่านระบบ CMU e-Document",
        link: "/FILE_GENERAL/MANNUL/mn_52_2.pdf",
        type: "pdf",
        date: "4 กุมภาพันธ์ุ 2568",
      },

      {
        id: 2,
        title: "คู่มือการใช้งานระบบการจัดทำวาระการประชุม",
        link: "/FILE_GENERAL/MANNUL/manual-full-V0.1.pdf",
        type: "pdf",
        date: "4 กุมภาพันธ์ุ 2568",
      },
    ];

    // ฟังก์ชันสำหรับการค้นหา
    const handleSearch = (searchValue) => {
      const filtered = dataIndex1.filter(
        (item) =>
          item.title.toLowerCase().includes(searchValue.toLowerCase()) ||
          item.date.toLowerCase().includes(searchValue.toLowerCase())
      );
      setFilteredData(filtered);
    };

    // เรียกใช้ handleSearch เมื่อ search หรือ tabActive เปลี่ยนแปลง
    useEffect(() => {
      handleSearch(search);
    }, [search, tabActive]);

    return (
      <>
        <div className="flex flex-col gap-3">
          {/* ช่องค้นหา */}
          <div className="flex justify-end items-center px-5">
            <div className="relative flex justify-end items-center">
              <input
                onChange={(e) => setSearch(e.target.value)}
                type="search"
                placeholder="ค้นหา"
                className="bg-gray-100 px-4 py-2 rounded-full focus:outline-none focus:ring-2 focus:ring-[#9e76b4] focus:border-transparent"
              />
            </div>
          </div>

          {/* ตารางข้อมูล */}
          <div className="flex justify-start items-center">
            <div className="bg-white shadow-md rounded-lg overflow-hidden md:w-50 w-full mx-4">
              <div className="overflow-x-auto overflow-y-scroll h-96 custom-scrollbar">
                <table className="min-w-full border-collapse border border-gray-200">
                  <thead className="bg-gray-50">
                    <tr>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border border-gray-200">
                        ดาวน์โหลด
                      </th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border border-gray-200">
                        ชื่อไฟล์
                      </th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border border-gray-200">
                        วันที่
                      </th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border border-gray-200">
                        ประเภทไฟล์
                      </th>
                    </tr>
                  </thead>
                  <tbody className="bg-white divide-y divide-gray-200">
                    {filteredData.map((item, index) => (
                      <tr key={index}>
                        <td
                          onClick={() => window.open(item.link)}
                          className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 border border-gray-200"
                        >
                          <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800 cursor-pointer">
                            ดาวน์โหลด
                          </span>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 border border-gray-200">
                          {item.title}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 border border-gray-200">
                          {item.date}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900 border border-gray-200">
                          <img
                            src={
                              item.type === "word"
                                ? iconWord
                                : item.type === "pdf"
                                ? iconPDF
                                : iconExcel
                            }
                            alt=""
                            className="w-8 h-8"
                          />
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  };

  const PlanOperation = () => {
    const iconWord =
      "https://img.icons8.com/?size=100&id=13674&format=png&color=000000";
    const iconPDF =
      "https://img.icons8.com/?size=100&id=aBrh3QHCPxYu&format=png&color=000000";
    const iconExcel =
      "https://img.icons8.com/?size=100&id=13654&format=png&color=000000";

    const [tabActive, setTabActive] = useState(1);
    const [search, setSearch] = useState("");
    const [filteredData, setFilteredData] = useState([]);

    const dataIndex1 = [
      {
        id: 1,
        title: "แผนกลยุทธ์คณะสัตวแพทยศาสตร์ ประจำปีงบประมาณ พ.ศ.2566-2569 ",
        link: "/FILE_GENERAL/PLAN/ทบทวนแผนกลยุทธ์คณะสัตวแพทยศาสตร์ ปี 2566-2569.pdf",
        type: "pdf",
        date: "4 กุมภาพันธุ์ 2568",
      },
    ];

    // ฟังก์ชันสำหรับการค้นหา
    const handleSearch = (searchValue) => {
      const filtered = dataIndex1.filter(
        (item) =>
          item.title.toLowerCase().includes(searchValue.toLowerCase()) ||
          item.date.toLowerCase().includes(searchValue.toLowerCase())
      );
      setFilteredData(filtered);
    };

    // เรียกใช้ handleSearch เมื่อ search หรือ tabActive เปลี่ยนแปลง
    useEffect(() => {
      handleSearch(search);
    }, [search, tabActive]);

    return (
      <>
        <div className="flex flex-col gap-3">
          {/* ช่องค้นหา */}
          <div className="flex justify-end items-center px-5">
            <div className="relative flex justify-end items-center">
              <input
                onChange={(e) => setSearch(e.target.value)}
                type="search"
                placeholder="ค้นหา"
                className="bg-gray-100 px-4 py-2 rounded-full focus:outline-none focus:ring-2 focus:ring-[#9e76b4] focus:border-transparent"
              />
            </div>
          </div>

          {/* ตารางข้อมูล */}
          <div className="flex justify-start items-center">
            <div className="bg-white shadow-md rounded-lg overflow-hidden md:w-50 w-full mx-4">
              <div className="overflow-x-auto overflow-y-scroll h-96 custom-scrollbar">
                <table className="min-w-full border-collapse border border-gray-200">
                  <thead className="bg-gray-50">
                    <tr>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border border-gray-200">
                        ดาวน์โหลด
                      </th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border border-gray-200">
                        ชื่อไฟล์
                      </th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border border-gray-200">
                        วันที่
                      </th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border border-gray-200">
                        ประเภทไฟล์
                      </th>
                    </tr>
                  </thead>
                  <tbody className="bg-white divide-y divide-gray-200">
                    {filteredData.map((item, index) => (
                      <tr key={index}>
                        <td
                          onClick={() => window.open(item.link)}
                          className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 border border-gray-200"
                        >
                          <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800 cursor-pointer">
                            ดาวน์โหลด
                          </span>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 border border-gray-200">
                          {item.title}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 border border-gray-200">
                          {item.date}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900 border border-gray-200">
                          <img
                            src={
                              item.type === "word"
                                ? iconWord
                                : item.type === "pdf"
                                ? iconPDF
                                : iconExcel
                            }
                            alt=""
                            className="w-8 h-8"
                          />
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  };

  const IDPDevelopmentPlan = () => {
    // const dataImage = [
    //   {
    //     id: 1,
    //     img: "/FILE_GENERAL/IDP/วาระกบส.-รายงานผลIDPรอบ 1ปี_Page1.png",
    //   },
    //   {
    //     id: 2,
    //     img: "/FILE_GENERAL/IDP/วาระกบส.-รายงานผลIDPรอบ 1ปี_Page2.png",
    //   },
    // ];
    // return (
    //   <>
    //     <div className="custom-scrollbar overflow-y-scroll lg:h-[500px] ">
    //       <div className="flex flex-col justify-center items-center mx-auto gap-5">
    //         {dataImage.map((item) => (
    //           <img
    //             key={item.id}
    //             src={item.img}
    //             alt=""
    //             className="w-50 object-cover rounded-lg overflow-hidden"
    //           />
    //         ))}
    //       </div>
    //     </div>
    //   </>
    // );

    const iconWord =
      "https://img.icons8.com/?size=100&id=13674&format=png&color=000000";
    const iconPDF =
      "https://img.icons8.com/?size=100&id=aBrh3QHCPxYu&format=png&color=000000";
    const iconExcel =
      "https://img.icons8.com/?size=100&id=13654&format=png&color=000000";

    const [tabActive, setTabActive] = useState(1);
    const [search, setSearch] = useState("");
    const [filteredData, setFilteredData] = useState([]);

    const dataIndex1 = [
      {
        id: 1,
        title: "รายงานผล IDP รอบ 1ปี",
        link: "/FILE_GENERAL/IDP/วาระกบส.-รายงานผลIDPรอบ 1ปี.pdf",
        type: "pdf",
        date: "18 ธันวาคม 2567",
      },
    ];

    // ฟังก์ชันสำหรับการค้นหา
    const handleSearch = (searchValue) => {
      const filtered = dataIndex1.filter(
        (item) =>
          item.title.toLowerCase().includes(searchValue.toLowerCase()) ||
          item.date.toLowerCase().includes(searchValue.toLowerCase())
      );
      setFilteredData(filtered);
    };

    // เรียกใช้ handleSearch เมื่อ search หรือ tabActive เปลี่ยนแปลง
    useEffect(() => {
      handleSearch(search);
    }, [search, tabActive]);

    return (
      <>
        <div className="flex flex-col gap-3">
          {/* ช่องค้นหา */}
          <div className="flex justify-end items-center px-5">
            <div className="relative flex justify-end items-center">
              <input
                onChange={(e) => setSearch(e.target.value)}
                type="search"
                placeholder="ค้นหา"
                className="bg-gray-100 px-4 py-2 rounded-full focus:outline-none focus:ring-2 focus:ring-[#9e76b4] focus:border-transparent"
              />
            </div>
          </div>

          {/* ตารางข้อมูล */}
          <div className="flex justify-start items-center">
            <div className="bg-white shadow-md rounded-lg overflow-hidden md:w-50 w-full mx-4">
              <div className="overflow-x-auto overflow-y-scroll h-96 custom-scrollbar">
                <table className="min-w-full border-collapse border border-gray-200">
                  <thead className="bg-gray-50">
                    <tr>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border border-gray-200">
                        ดาวน์โหลด
                      </th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border border-gray-200">
                        ชื่อไฟล์
                      </th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border border-gray-200">
                        วันที่
                      </th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border border-gray-200">
                        ประเภทไฟล์
                      </th>
                    </tr>
                  </thead>
                  <tbody className="bg-white divide-y divide-gray-200">
                    {filteredData.map((item, index) => (
                      <tr key={index}>
                        <td
                          onClick={() => window.open(item.link)}
                          className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 border border-gray-200"
                        >
                          <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800 cursor-pointer">
                            ดาวน์โหลด
                          </span>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 border border-gray-200">
                          {item.title}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 border border-gray-200">
                          {item.date}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900 border border-gray-200">
                          <img
                            src={
                              item.type === "word"
                                ? iconWord
                                : item.type === "pdf"
                                ? iconPDF
                                : iconExcel
                            }
                            alt=""
                            className="w-8 h-8"
                          />
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  };

  const EventPlan = () => {
    const iconWord =
      "https://img.icons8.com/?size=100&id=13674&format=png&color=000000";
    const iconPDF =
      "https://img.icons8.com/?size=100&id=aBrh3QHCPxYu&format=png&color=000000";
    const iconExcel =
      "https://img.icons8.com/?size=100&id=13654&format=png&color=000000";

    const [tabActive, setTabActive] = useState(1);
    const [search, setSearch] = useState("");
    const [filteredData, setFilteredData] = useState([]);

    const dataIndex1 = [
      {
        id: 1,
        title: "แต่งตั้งคณะกรรมการดูแลด้านการทำนุบำรุงฯ",
        link: "https://www.vet.cmu.ac.th/webmed/adminvet/document/sec1/114-2562.pdf",
        number: "144/2562",
        type: "pdf",
        date: "19 กรกฎาคม 2562",
      },
    ];

    // ฟังก์ชันสำหรับการค้นหา
    const handleSearch = (searchValue) => {
      const filtered = dataIndex1.filter(
        (item) =>
          item.title.toLowerCase().includes(searchValue.toLowerCase()) ||
          item.date.toLowerCase().includes(searchValue.toLowerCase())
      );
      setFilteredData(filtered);
    };

    // เรียกใช้ handleSearch เมื่อ search หรือ tabActive เปลี่ยนแปลง
    useEffect(() => {
      handleSearch(search);
    }, [search, tabActive]);

    return (
      <>
        <div className="flex flex-col gap-3">
          {/* ช่องค้นหา */}
          <div className="flex justify-end items-center px-5">
            <div className="relative flex justify-end items-center">
              <input
                onChange={(e) => setSearch(e.target.value)}
                type="search"
                placeholder="ค้นหา"
                className="bg-gray-100 px-4 py-2 rounded-full focus:outline-none focus:ring-2 focus:ring-[#9e76b4] focus:border-transparent"
              />
            </div>
          </div>

          {/* ตารางข้อมูล */}
          <div className="flex justify-start items-center">
            <div className="bg-white shadow-md rounded-lg overflow-hidden md:w-50 w-full mx-4">
              <div className="overflow-x-auto overflow-y-scroll h-96 custom-scrollbar">
                <table className="min-w-full border-collapse border border-gray-200">
                  <thead className="bg-gray-50">
                    <tr>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border border-gray-200">
                        ดาวน์โหลด
                      </th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border border-gray-200">
                        ชื่อไฟล์
                      </th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border border-gray-200">
                        เลขคำสั่ง
                      </th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border border-gray-200">
                        วันที่
                      </th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border border-gray-200">
                        ประเภทไฟล์
                      </th>
                    </tr>
                  </thead>
                  <tbody className="bg-white divide-y divide-gray-200">
                    {filteredData.map((item, index) => (
                      <tr key={index}>
                        <td
                          onClick={() => window.open(item.link)}
                          className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 border border-gray-200"
                        >
                          <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800 cursor-pointer">
                            ดาวน์โหลด
                          </span>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 border border-gray-200">
                          {item.title}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 border border-gray-200">
                          {item.number}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 border border-gray-200">
                          {item.date}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900 border border-gray-200">
                          <img
                            src={
                              item.type === "word"
                                ? iconWord
                                : item.type === "pdf"
                                ? iconPDF
                                : iconExcel
                            }
                            alt=""
                            className="w-8 h-8"
                          />
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  };

  const DownloadForm = () => {
    // const dataIndex1 = [
    //   {
    //     id: 1,
    //     title: "แบบฟอร์มลาออกพนักงานมหาวิทยาลัย",
    //     link: "/FILE_GENERAL/FORM_DOWNLOAD/01resign-form-employee.docx",
    //     type: "word",
    //     date: "4 กุมภาพันธุ์ 2568",
    //   },
    //   {
    //     id: 2,
    //     title: "แบบฟอร์มลาออกพนักงานโครงการ PetCMU",
    //     link: "/FILE_GENERAL/FORM_DOWNLOAD/resign-form-petcmu.docx",
    //     type: "word",
    //     date: "4 กุมภาพันธุ์ 2568",
    //   },
    //   {
    //     id: 3,
    //     title: "แบบฟอร์มลาออกพนักงานส่วนงาน ศูนย์ช้นสูตรฯ",
    //     link: "/FILE_GENERAL/FORM_DOWNLOAD/resign-form-diag.doc",
    //     type: "word",
    //     date: "4 กุมภาพันธุ์ 2568",
    //   },
    //   {
    //     id: 4,
    //     title: "แบบฟอร์มลาออกพนักงานส่วนงานสังกัด โรงพยาบาลสัตว์",
    //     link: "/FILE_GENERAL/FORM_DOWNLOAD/resign-form-hospital.doc",
    //     type: "word",
    //     date: "4 กุมภาพันธุ์ 2568",
    //   },
    // ];

    const [search, setSearch] = useState("");
    const [filteredData, setFilteredData] = useState([]);
    const [tabActive, setTabActive] = useState(1);
    const iconWord =
      "https://img.icons8.com/?size=100&id=13674&format=png&color=000000";
    const iconPDF =
      "https://img.icons8.com/?size=100&id=aBrh3QHCPxYu&format=png&color=000000";
    const iconExcel =
      "https://img.icons8.com/?size=100&id=13654&format=png&color=000000";

    const dataIndex1 = [
      {
        id: 1,
        title: "แต่งตั้งอธิการบดีมหาวิทยาลัยเชียงใหม่",
        link: "/FILE_GENERAL/001/T_0006-ประกาศแต่งตั้งอธิการบดีในราชกิจจานุเบกษา.PDF.pdf",
        number: "",
        type: "pdf",
        date: "19 สิงหาคม 2565",
      },
      {
        id: 2,
        title: "แต่งตั้งบุคคลให้ดำรงตำแหน่งรองอธิการบดีมหาวิทยาลัยเชียงใหม่",
        link: "/FILE_GENERAL/001/คำสั่ง-แต่งตั้งรองอธิการบดี-มช.-2565.pdf",
        number: "2516/2565",
        type: "pdf",
        date: "27 สิงหาคม 2565",
      },
      {
        id: 3,
        title: "แต่งตั้งคณบดีคณะสัตวแพทยศาสตร์ มหาวิทยาลัยเชียงใหม่",
        link: "/FILE_GENERAL/001/คำสั่งแต่งตั้งคณบดี 25 มี.ค.65.pdf",
        number: "3881/2564",
        type: "pdf",
        date: "18 ธันวาคม 2564",
      },
    ];
    const dataIndex2 = [
      {
        id: 1,
        title: "มอบหมายและมอบอำนาจให้ผู้ดำรงตำแหน่งรองคณบดี และผู้ช่วยคณบดี",
        link: "/FILE_GENERAL/002/(036)มอบหมาบโดยคณะ อ.นิดหน่อย อ.สหัสชัย.pdf",
        number: "036/2568",
        type: "pdf",
        date: "30 มกราคม 2568",
      },
    ];
    const dataIndex3 = [
      // {
      //   id: 1,
      //   title: "ประกาศมหาวิทยาลัย/1",
      //   link: "#!",
      //   type: "pdf",
      //   date: "12 กุมภาพันธ์ 2566",
      // },
    ];
    const dataIndex4 = [
      // {
      //   id: 1,
      //   title: "ประกาศคณะฯ/1",
      //   link: "#!",
      //   type: "pdf",
      //   date: "12 กุมภาพันธ์ 2566",
      // },
    ];

    const handleActviceChange = (index) => {
      setTabActive(index);
      handleSearch(search, index);
    };

    const handleSearch = (searchValue, index) => {
      let data = [];
      if (index === 1) data = dataIndex1;
      if (index === 2) data = dataIndex2;
      if (index === 3) data = dataIndex3;
      if (index === 4) data = dataIndex4;

      const filtered = data.filter((item) =>
        item.title.toLowerCase().includes(searchValue.toLowerCase())
      );
      setFilteredData(filtered);
    };

    useEffect(() => {
      handleSearch(search, tabActive);
    }, [search, tabActive]);

    const renderTable = (data) => {
      return data.map((item, index) => (
        <tr key={index}>
          <td
            onClick={() => window.open(item.link)}
            className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 border border-gray-200"
          >
            <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800 cursor-pointer">
              ดาวน์โหลด
            </span>
          </td>
          <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 border border-gray-200">
            {item.title}
          </td>
          <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 border border-gray-200">
            {item.number}
          </td>
          <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 border border-gray-200">
            {item.date}
          </td>
          <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900 border border-gray-200">
            <img
              src={
                item.type === "word"
                  ? iconWord
                  : item.type === "pdf"
                  ? iconPDF
                  : iconExcel
              }
              alt=""
              className="w-8 h-8"
            />
          </td>
        </tr>
      ));
    };

    return (
      <>
        <div className="flex flex-col gap-3">
          <div className="flex justify-between items-center px-5">
            <div className="md:bg-gray-100 shadow-sm px-2 py-2  md:flex justify-start items-center gap-2 rounded-full">
              <div
                onClick={() => handleActviceChange(1)}
                className={`px-4 py-2 rounded-full flex gap-x-2 items-center hover:bg-[#9e76b4] ${
                  tabActive === 1 ? "bg-[#9e76b4] text-white" : "text-[#5eafd2]"
                } text-sm hover:text-white cursor-pointer transition-all duration-500 `}
              >
                <i className="fa fa-file"></i>
                <span>คำสั่งมหาวิทยาลัย</span>
              </div>
              <span className="md:block hidden">|</span>
              <div
                onClick={() => handleActviceChange(2)}
                className={`px-4 py-2 rounded-full flex gap-x-2 items-center hover:bg-[#9e76b4] ${
                  tabActive === 2 ? "bg-[#9e76b4] text-white" : "text-[#5eafd2]"
                } text-sm hover:text-white cursor-pointer transition-all duration-500 `}
              >
                <i className="fa fa-file"></i>
                <span>คำสั่งคณะฯ</span>
              </div>
              <span className="md:block hidden">|</span>
              <div
                onClick={() => handleActviceChange(3)}
                className={`px-4 py-2 rounded-full flex gap-x-2 items-center hover:bg-[#9e76b4] ${
                  tabActive === 3 ? "bg-[#9e76b4] text-white" : "text-[#5eafd2]"
                } text-sm hover:text-white cursor-pointer transition-all duration-500 `}
              >
                <i className="fa fa-file"></i>
                <span>ประกาศมหาวิทยาลัย</span>
              </div>
              <span className="md:block hidden">|</span>
              <div
                onClick={() => handleActviceChange(4)}
                className={`px-4 py-2 rounded-full flex gap-x-2 items-center hover:bg-[#9e76b4] ${
                  tabActive === 4 ? "bg-[#9e76b4] text-white" : "text-[#5eafd2]"
                } text-sm hover:text-white cursor-pointer transition-all duration-500 `}
              >
                <i className="fa fa-file"></i>
                <span>ประกาศคณะฯ</span>
              </div>
            </div>
            <div className="relative flex justify-end items-center">
              <input
                onChange={(e) => setSearch(e.target.value)}
                type="search"
                placeholder="ค้นหา"
                className="text-sm bg-gray-100 px-4 py-2 rounded-full focus:outline-none focus:ring-2 focus:ring-[#9e76b4] focus:border-transparent"
              />
            </div>
          </div>

          <div className="flex justify-start items-center">
            <div className="bg-white shadow-md rounded-lg overflow-hidden  md:w-50 w-full mx-4">
              <div className="overflow-x-auto overflow-y-scroll h-96 custom-scrollbar">
                <table className="min-w-full border-collapse border border-gray-200 ">
                  <thead className="bg-gray-50">
                    <tr>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border border-gray-200">
                        ดาวน์โหลด
                      </th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border border-gray-200">
                        ชื่อไฟล์
                      </th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border border-gray-200">
                        เลขคำสั่งที่
                      </th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border border-gray-200">
                        วันที่
                      </th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border border-gray-200">
                        ประเภทไฟล์
                      </th>
                    </tr>
                  </thead>
                  <tbody className="bg-white divide-y divide-gray-200">
                    {renderTable(filteredData)}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  };

  return (
    <>
      <Navbar />
      {/* Main selection */}
      <div className="w-full h-full sm:h-full md:h-full lg:h-full mb-[130px] pb-[100px]">
        <div className="container mx-auto w-full px-5 py-5 md:px-0 md:py-0">
          <div className=" grid gid-cols-1 md:grid-cols-3 gap-5 mt-0 md:mt-10 mb-20">
            <div className="w-full flex justify-center order-2 md:order-1">
              <div className="flex flex-col items-start gap-4 p-4 bg-[#9e76b43d] rounded-lg shadow-md">
                <div className="flex items-center gap-x-3">
                  <div className="border-2 border-[#5eafd2] bg-white px-[12px] py-2 rounded-xl">
                    <span className="text-5xl text-[#5eafd2] font-bold">V</span>
                  </div>
                  <div>
                    <span className="text-xl font-bold text-cyan-600">
                      Versatility
                    </span>
                    <p className="text-sm text-gray-500">
                      ความสามารถในการปรับตัว มีความยืดหยุ่นในการทำงาน
                      และหน้าที่ต่างๆ ได้อย่างหลากหลาย และมีประสิทธิ์ภาพ
                    </p>
                  </div>
                </div>
                <div className="flex items-center gap-x-3">
                  <div className="border-2 border-[#5eafd2] bg-white px-[10px] py-2 rounded-xl">
                    <span className="text-5xl text-[#5eafd2] font-bold">M</span>
                  </div>
                  <div>
                    <span className="text-xl font-bold text-cyan-600">
                      Motivation{" "}
                    </span>
                    <p className="text-sm text-gray-500">
                      ส่งเสริมและผลักดัน
                      ให้กำลังใจในการทำงานระหว่างกัรและกันในผู้ร่วมงาน
                      เพื่อให้มีความสัมพันธ์และประสิทธิภาพที่ดียิ่งขึ้น
                    </p>
                  </div>
                </div>
                <div className="flex items-center gap-x-3">
                  <div className="border-2 border-[#5eafd2] bg-white px-[13px] py-2 rounded-xl">
                    <span className="text-5xl text-[#5eafd2] font-bold">C</span>
                  </div>
                  <div>
                    <span className="text-xl font-bold text-cyan-600">
                      Community Engagemment{" "}
                    </span>
                    <p className="text-sm text-gray-500">
                      มุ่งเน้นท้องถิ่น และมีความรับผิดชอบต่อสังคม
                    </p>
                  </div>
                </div>
                <div className="flex items-center gap-x-3">
                  <div className="border-2 border-[#5eafd2] bg-white px-[10px] py-2 rounded-xl">
                    <span className="text-5xl text-[#5eafd2] font-bold">M</span>
                  </div>
                  <div>
                    <span className="text-xl font-bold text-cyan-600">
                      Morality{" "}
                    </span>
                    <p className="text-sm text-gray-500">
                      ยึดหลักธรรมมาภิบาล เชิดชูคุณธรรม
                      พัฒนาจิตอาสา/จิตสาธารณะ/จิตบริการ
                    </p>
                  </div>
                </div>
                <div className="flex items-center gap-x-3">
                  <div className="border-2 border-[#5eafd2] bg-white px-[10px] py-2 rounded-xl">
                    <span className="text-5xl text-[#5eafd2] font-bold">U</span>
                  </div>
                  <div>
                    <span className="text-xl font-bold text-cyan-600">
                      Unity{" "}
                    </span>
                    <p className="text-sm text-gray-500">
                      ทำงานเป็นทีม บุคลากรสามัคคี และเป็นองค์กรแห่งความสุข
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="w-full flex justify-center order-1 md:order-2">
              <div className="flex flex-col  items-center gap-3">
                <div className="">
                  <img src="/VMCMU.png" alt="" />
                </div>
                <h1 className="text-[#5eafd2]">
                  VM<span className="text-[#9e76b4]">CMU</span>
                </h1>
                <p className="text-gray-600 text-sm">
                  Versatility Motivation Community Engagemment Morality Unity
                </p>
                <h5 className="text-center text-gray-600">
                  Faculty of Veterinary Medicine
                </h5>
                <div className="flex flex-col text-center">
                  <h1 className="text-2xl text-gray-600">วิสัยทัศน์</h1>
                  <p className="text-sm text-gray-600">
                    คณะสัตวแพทยศาสตร์ มหาวิทยาลัยเชียงใหม่
                    เป็นสถานศึกษาชั้นนำในเอเชีย และรับใช้สังคม
                  </p>
                </div>
              </div>
            </div>
            <div className="w-full flex justify-center order-3 md:order-3">
              <div className="flex flex-col items-start gap-4 p-4 bg-[#5eafd260] rounded-lg shadow-md">
                <h1 className="text-3xl text-[#9e76b4]">พันธกิจ และเป้าหมาย</h1>
                <div className="flex items-center gap-x-3">
                  <i className="fa-solid fa-arrows-to-dot text-[#9e76b4]"></i>
                  <p className="text-gray-500">
                    จัดการศึกษาระดับอุดมศึกษาและวิชาชีพชั้นสูงโดยมุ่งเน้นความเป็นเลิศทางวิชาการ
                    บัณฑิตมีคุณภาพตามมาตรฐานสากล และรอบรู้คู่คุณธรรม
                    ตามหลักปรัชญาเศรษฐกิจพอเพียง
                  </p>
                </div>
                <div className="flex items-center gap-x-3">
                  <i className="fa-solid fa-arrows-to-dot text-[#9e76b4]"></i>
                  <p className="text-gray-500">
                    ผลิตผลงานวิจัยทางสัตวแพทย์
                    เพื่อสามารถสนับสนุนการเรียนการสอนและการถ่ายทอดเทคโนโลยี
                    เพื่อพัฒนาเศรษฐกิจสังคมของประเทศ
                  </p>
                </div>
                <div className="flex items-center gap-x-3">
                  <i className="fa-solid fa-arrows-to-dot text-[#9e76b4]"></i>
                  <p className="text-gray-500">
                    ให้บริการวิชาการแก่สังคม
                    มีส่วนร่วมพัฒนาชุมชนให้เข้มแข็งด้วยหลักปรัชญาเศรษฐกิจพอเพียง
                  </p>
                </div>
                <div className="flex items-center gap-x-3">
                  <i className="fa-solid fa-arrows-to-dot text-[#9e76b4]"></i>
                  <p className="text-gray-500">
                    ทำนุบำรุงศาสนา ศิลปวัฒนธรรม
                    อนุรักษ์และพัฒนาทรัพยากรธรรมชาติและสิ่งแวดล้อมอย่างยั่งยืน
                    เพื่อความเป็นเอกลักษณ์ของท้องถิ่นภาคเหนือ
                  </p>
                </div>
                <div className="flex items-center gap-x-3">
                  <i className="fa-solid fa-arrows-to-dot text-[#9e76b4]"></i>
                  <p className="text-gray-500">
                    พัฒนาระบบบริหารจัดการ ด้วยหลักธรรมมาภิบาล
                    พึ่งตนเองโดยใช้หลักปรัชญาเศรษฐกิจพอเพียง
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="container max-w-7xl mx-auto w-full pb=[100px]">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 px-8 md:px-0">
            <Link
              to="#!"
              onClick={() =>
                showModalPreview({
                  title: "คำสั่ง/ประกาศ",
                })
              }
              className="flex flex-col justify-center items-center gap-y-4 transition-all duration-400 text-gray-500 ease-in-out hover:scale-105 hover:text-amber-200 hover:bg-gradient-to-b md:hover:bg-gradient-to-r hover:from-blue-300 hover:to-blue-800 hover:no-underline rounded-lg shadow-lg p-4"
            >
              <img
                src="https://img.icons8.com/?size=100&id=119104&format=png&color=000000"
                alt=""
              />
              <span className="text-md font-[600]">คำสั่ง/ประกาศ</span>
            </Link>
            <Link
              to="#!"
              onClick={() =>
                showModalPreview({
                  title: "มติที่ประชุม",
                })
              }
              className="flex flex-col justify-center items-center gap-y-4 transition-all duration-400 text-gray-500 ease-in-out hover:scale-105 hover:text-amber-200 hover:bg-gradient-to-b md:hover:bg-gradient-to-r hover:from-blue-300 hover:to-blue-800 hover:no-underline rounded-lg shadow-lg p-4"
            >
              <img
                src="https://img.icons8.com/?size=100&id=103937&format=png&color=000000"
                alt=""
              />
              <span className="text-md font-[600]">มติที่ประชุม</span>
            </Link>
            <Link
              to="#!"
              onClick={() =>
                showModalPreview({
                  title: "KM",
                })
              }
              className="flex flex-col justify-center items-center gap-y-4 transition-all duration-400 text-gray-500 ease-in-out hover:scale-105 hover:text-amber-200 hover:bg-gradient-to-b md:hover:bg-gradient-to-r hover:from-blue-300 hover:to-blue-800 hover:no-underline rounded-lg shadow-lg p-4"
            >
              <img
                src="https://img.icons8.com/?size=100&id=obW9frsFQonW&format=png&color=000000"
                alt=""
              />
              <span className="text-md font-[600]">Knowledge Management</span>
            </Link>
            <Link
              to="#!"
              onClick={() =>
                showModalPreview({
                  title: "คู่มือปฏิบัติงาน",
                })
              }
              className="flex flex-col justify-center items-center gap-y-4 transition-all duration-400 text-gray-500 ease-in-out hover:scale-105 hover:text-amber-200 hover:bg-gradient-to-b md:hover:bg-gradient-to-r hover:from-blue-300 hover:to-blue-800 hover:no-underline rounded-lg shadow-lg p-4"
            >
              <img
                src="https://img.icons8.com/?size=100&id=119020&format=png&color=000000"
                alt=""
              />
              <span className="text-md font-[600]">คู่มือปฏิบัติงาน</span>
            </Link>
            <Link
              to={"#!"}
              onClick={() =>
                showModalPreview({
                  title: "แผนปฏิบัติการ",
                })
              }
              className="flex flex-col justify-center items-center gap-y-4 transition-all duration-400 text-gray-500 ease-in-out hover:scale-105 hover:text-amber-200 hover:bg-gradient-to-b md:hover:bg-gradient-to-r hover:from-blue-300 hover:to-blue-800 hover:no-underline rounded-lg shadow-lg p-4 "
            >
              <img
                src="https://img.icons8.com/?size=100&id=rnwtSv4H3pXk&format=png&color=000000"
                alt=""
              />
              <span className="text-md font-[600]">แผนปฏิบัติการ</span>
            </Link>
            <Link
              to={"#!"}
              onClick={() =>
                showModalPreview({
                  title: "IDP",
                })
              }
              className="flex flex-col justify-center items-center gap-y-4 transition-all duration-400 text-gray-500 ease-in-out hover:scale-105 hover:text-amber-200 hover:bg-gradient-to-b md:hover:bg-gradient-to-r hover:from-blue-300 hover:to-blue-800 hover:no-underline rounded-lg shadow-lg p-4 "
            >
              <img
                src="https://img.icons8.com/?size=100&id=4CUEjAZV6FOg&format=png&color=000000"
                alt=""
              />
              <span className="text-md font-[600]">
                การติดตามการดำเนินงาน IDP
              </span>
            </Link>
            <Link
              to={"#!"}
              onClick={() =>
                showModalPreview({
                  title: "งานประชุมและกิจกรรมพันธกิจด้านทำนุบำรุง",
                })
              }
              className="flex flex-col justify-center items-center gap-y-4 transition-all duration-400 text-gray-500 ease-in-out hover:scale-105 hover:text-amber-200 hover:bg-gradient-to-b md:hover:bg-gradient-to-r hover:from-blue-300 hover:to-blue-800 hover:no-underline rounded-lg shadow-lg p-4 "
            >
              <img
                src="https://img.icons8.com/?size=100&id=wOKadQVnq2xz&format=png&color=000000"
                alt=""
              />
              <span className="text-center text-md font-[600]">
                งานประชุมและกิจกรรมพันธกิจด้านทำนุบำรุง
              </span>
            </Link>
            {/* <Link
              to={"#!"}
              onClick={() =>
                showModalPreview({
                  title: "แบบฟอร์มต่างๆ",
                })
              }
              className="flex flex-col justify-center items-center gap-y-4 transition-all duration-400 text-gray-500 ease-in-out hover:scale-105 hover:text-amber-200 hover:bg-gradient-to-b md:hover:bg-gradient-to-r hover:from-blue-300 hover:to-blue-800 hover:no-underline rounded-lg shadow-lg p-4 "
            >
              <img
                src="https://img.icons8.com/?size=100&id=cnDcRP3O64a9&format=png&color=000000"
                alt=""
              />
              <span className="text-center text-md font-[600]">
                แบบฟอร์มต่างๆ
              </span>
            </Link> */}
          </div>
        </div>
      </div>
      {/* Main selection */}
      <Footer />

      <Modal
        title={
          titleModal === "IDP"
            ? "การติดตามการดำเนินงาน IDP"
            : titleModal === "งานประชุมและกิจกรรมพันธกิจด้านทำนุบำรุง"
            ? "งานประชุมและกิจกรรมพันธกิจด้านทำนุบำรุงศิลปวัฒนธรรมและระดมเงินทุนสมทบกองทุนสงเคราะห์สัตว์"
            : titleModal === "KM"
            ? "Knowledge Management"
            : titleModal
        }
        show={showModal}
        onClose={closeModal}
        size="max-w-5xl"
      >
        {titleModal === "คำสั่ง/ประกาศ" && <AnnouncementAndOrder />}
        {titleModal === "มติที่ประชุม" && <MeetingResolution />}
        {titleModal === "KM" && <KnowledgeManagement />}
        {titleModal === "คู่มือปฏิบัติงาน" && <ManualGa />}
        {titleModal === "แผนปฏิบัติการ" && <PlanOperation />}
        {titleModal === "IDP" && <IDPDevelopmentPlan />}
        {titleModal === "งานประชุมและกิจกรรมพันธกิจด้านทำนุบำรุง" && (
          <EventPlan />
        )}
        {titleModal === "แบบฟอร์มต่างๆ" && <DownloadForm />}
      </Modal>
    </>
  );
}
